// extracted by mini-css-extract-plugin
module.exports = {"title":"_23KlD8mc7Kj_sFnIr0bS1q"};